var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documents.length)?_c('div',_vm._l((_vm.caseActivityDetails.config.collectors),function(collector){return _c('CollectorDetails',{key:collector.id,attrs:{"collector":collector,"documents":_vm.documents.filter(doc => doc.collector === collector.id)}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }